/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempChevronsMenuLeftSmall: {
  name: 'temp-chevrons-menu-left-small';
  data: string;
} = {
  name: 'temp-chevrons-menu-left-small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12.375 14.7A1 1 0 0 0 14 13.92v-3.84a1 1 0 0 0-1.625-.78l-2.399 1.92a1 1 0 0 0 0 1.56l2.4 1.92Z" fill="currentColor"/></svg>`,
};
